// src/app/store.ts
import { configureStore } from '@reduxjs/toolkit'
import {
  BillingStateSlice,
  CategoriesSlice,
  ClientInfoSlice,
  PreloadDataSlice,
  ProductsSlice,
  PropsSlice,
  QuantityTypeSlice,
  TableSession,
  UISlice,
  authSlice,
} from './reducers'

export const store = configureStore({
  reducer: {
    //NEW
    clientInfo: ClientInfoSlice.reducer,
    authentication: authSlice.reducer,
    allproducts: ProductsSlice.reducer,
    categories: CategoriesSlice.reducer,
    quantityTypes: QuantityTypeSlice.reducer,
    billing: BillingStateSlice.reducer,
    ui: UISlice.reducer,
    preloadData: PreloadDataSlice.reducer,
    props: PropsSlice.reducer,
    table: TableSession.reducer
  },
})

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch
